import WsProvider from './provider/WSProvider'

var serviceName = "webservis";
var moduleName = "kampanya";

var bonusService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,

    bonusEkle(musteriID, bonusFiyati, kullanmaLimiti, indirimNotu, sonKullanmaTarihi, durum) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            musteriID, bonusFiyati, kullanmaLimiti, indirimNotu, sonKullanmaTarihi, durum,
            serviceName: moduleName,
            methodName: "bonusEkle"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },


    musteriBonusList(musteriID, durum, baslangic, limit) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            musteriID, durum, baslangic, limit,
            serviceName: moduleName,
            methodName: "musteriBonusList"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },


    bonusGuncelle(musteriID, bonusID, bonusFiyati, kullanmaLimiti, indirimNotu, sonKullanmaTarihi, durum) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            musteriID, bonusID, bonusFiyati, kullanmaLimiti, indirimNotu, sonKullanmaTarihi, durum,
            serviceName: moduleName,
            methodName: "bonusGuncelle"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },


    bonusDurumDegistir(bonusID, durum, iptalSebebi) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            bonusID, durum, iptalSebebi,
            serviceName: moduleName,
            methodName: "bonusDurumGuncelle"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },


    bonusListele(durum, baslangic, limit) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            durum, baslangic, limit,
            serviceName: moduleName,
            methodName: "bonusListele"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },


    bonusDetay(bonusID) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            bonusID,
            serviceName: moduleName,
            methodName: "bonusDetay"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
}

export default bonusService